export default {"src":"/_next/static/media/other mobile.32d5a1db.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};